<pr-input-abstract [control]="control" [label]="label" [derrors]="derrors">
  <mat-select
    (selectionChange)="onInputChange($event)"
    [(value)]="values"
    [compareWith]="compareFn"
  >
    @for (option of options; track option) {
      <mat-option [value]="option.id">
        {{ option.label }}
      </mat-option>
    }
  </mat-select>
</pr-input-abstract>
